export const selectServiceList = (state) => state.services.list;
export const selectServiceListLoading = (state) => state.services.loadingList;

export const selectServices = (state) => state.services.services;
export const selectServicesLoading = (state)=> state.seervices.loadingServices

export const selectUserServices = (state)=> state.services.userServices;